import React from "react";
import classNames from "../classNames";
import dialog from "../Modal/dialog";

const defaultProps = {
    width: "100%",
    height: "100%",
};

function Image({className, width, height, style, fit, clickable, rounded, ...props}) {
    const _style = {
        width,
        height,
        cursor: clickable ? "pointer" : "default",
        ...style
    }
    const onClick = () => {
        if (clickable) {
            dialog.fire(
                {
                    component:
                        <Image
                            {...props} />,
                    footer: false,
                    closable: true,
                }
            );
        }
    }

    return (
        <div
            style={_style}
            className={classNames(className, "d-flex justify-content-center align-items-center")}>
            <img
                onClick={onClick}
                className={classNames(fit ? "w-100 h-100" : "mw-100 mh-100", rounded ? "rounded" : "")}
                style={fit ? {objectFit: "cover"} : {}}
                {...props}
            />
        </div>
    )
}

Image.defaultProps = defaultProps;
export default Image;